(function(){
  const SECTION_QP = 'quick-pick';

  // ----- Private modal -----
  let modal, content, dialog;

  // Page scroll lock (like preview)
  const _lock = { y: 0, pad: '' };
  function lockBody(){
    const body = document.body, doc = document.documentElement;
    _lock.y = window.scrollY || 0;
    const sbw = window.innerWidth - doc.clientWidth;
    _lock.pad = body.style.paddingRight;
    if (sbw > 0) body.style.paddingRight = sbw + 'px';
    body.style.position = 'fixed';
    body.style.top = -_lock.y + 'px';
    body.style.left = '0'; body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
  }
  function unlockBody(){
    const body = document.body;
    body.style.position = ''; body.style.top = '';
    body.style.left = ''; body.style.right = '';
    body.style.width = ''; body.style.overflow = '';
    body.style.paddingRight = _lock.pad || '';
    window.scrollTo(0, _lock.y || 0);
  }

  function ensureModal(){
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'qp-modal';
    modal.innerHTML = `
      <div class="qp-overlay"></div>
      <div class="qp-dialog" role="dialog" aria-modal="true" aria-label="Choose options">
        <button class="qp-close js-qp-close" aria-label="Close">&times;</button>
        <div class="qp-content" id="qp-content"></div>
      </div>`;
    document.body.appendChild(modal);
    content = modal.querySelector('#qp-content');
    dialog  = modal.querySelector('.qp-dialog');

    // Close on overlay click or any click outside dialog (mousedown + click for reliability)
    ['mousedown','click'].forEach(evt => {
      modal.addEventListener(evt, (e) => {
        if (!dialog.contains(e.target)) { e.preventDefault(); closeModal(); }
        if (e.target.closest('.js-qp-close')) { e.preventDefault(); closeModal(); }
      });
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (modal.classList.contains('is-open') && e.key === 'Escape') closeModal();
    });

    return modal;
  }

  function openModal(){ ensureModal(); modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); lockBody(); }
  function closeModal(){ if (!modal) return; modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); if (content) content.innerHTML=''; unlockBody(); }

  // ----- Tiny toast (inline styled) -----
  function toastNear(el, text){
    try {
      const t = document.createElement('div');
      t.textContent = text;
      t.style.position = 'fixed'; t.style.left = '0px'; t.style.top = '0px';
      t.style.transform = 'translate(-50%, 6px)';
      t.style.background = 'rgba(20,20,20,.88)'; t.style.color = '#fff';
      t.style.padding = '6px 10px'; t.style.borderRadius = '10px';
      t.style.fontSize = '12px'; t.style.fontWeight = '500'; t.style.lineHeight = '1';
      t.style.boxShadow = '0 4px 14px rgba(0,0,0,.12)'; t.style.zIndex = '2147483647';
      t.style.opacity = '0'; t.style.transition = 'opacity .18s ease, transform .18s ease';
      t.style.pointerEvents = 'none';
      document.body.appendChild(t);
      const r = (el?.getBoundingClientRect && el.getBoundingClientRect()) || {left:window.innerWidth/2,bottom:window.innerHeight/2,width:0};
      const left = Math.round(r.left + r.width/2);
      const top  = Math.min(window.innerHeight - 12, Math.round(r.bottom) + 10);
      t.style.left = left + 'px'; t.style.top  = top + 'px';
      requestAnimationFrame(() => { t.style.opacity = '1'; t.style.transform = 'translate(-50%, 0)'; });
      setTimeout(() => { t.style.opacity = '0'; t.style.transform = 'translate(-50%, 6px)'; setTimeout(() => t.remove(), 200); }, 1100);
    } catch(_){}
  }

  // ----- Fetch + render Quick Pick -----
  function openPicker(handle){
    ensureModal();
    return fetch(`/products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(SECTION_QP)}`, { credentials:'same-origin' })
      .then(r => r.ok ? r.text() : Promise.reject(r))
      .then(html => { content.innerHTML = html; wirePicker(content); openModal(); })
      .catch(()=> window.location.assign(`/products/${handle}`));
  }

  // ----- Add to cart -----
  function addToCart(variantId){
    return fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(r => r.ok ? r.json() : Promise.reject(r));
  }

  // Helpers that work for generic OR custom pickers
  function getOptionControls(root){
    const selects = Array.from(root.querySelectorAll('.qp-select, .qa-select, select[name^="options["]'));
    const radioNames = [];
    root.querySelectorAll('input[type="radio"][name^="options["]').forEach(r=>{
      if (!radioNames.includes(r.name)) radioNames.push(r.name);
    });
    return { selects, radioNames };
  }

  function currentVariantFromUi(variants, root){
    const { selects, radioNames } = getOptionControls(root);
    const vals = [];
    selects.forEach(s => vals.push(s.value));
    radioNames.forEach(name => {
      const checked = root.querySelector(`input[type="radio"][name="${name}"]:checked`);
      if (checked) vals.push(checked.value);
    });
    return variants.find(v =>
      (!v.option1 || v.option1 === vals[0]) &&
      (!v.option2 || v.option2 === vals[1]) &&
      (!v.option3 || v.option3 === vals[2])
    ) || null;
  }

  // ----- Wire picker UI -----
  function wirePicker(root){
    const jsonEl  = root.querySelector('#qp-variants-json');   // always present
    const priceEl = root.querySelector('#qp-price');           // always present
    const addBtn  = root.querySelector('#qp-add');             // always present

    let variants = [];
    try { variants = JSON.parse(jsonEl?.textContent || '[]'); } catch { variants = []; }

    const currency = (priceEl?.dataset.currency || document.documentElement.getAttribute('data-shop-currency') || 'USD').trim();
    const money = (cents) => {
      const amount = (Number(cents) || 0)/100;
      try { return new Intl.NumberFormat(undefined,{style:'currency',currency}).format(amount); }
      catch { return '$' + amount.toFixed(2); }
    };

    function updatePriceAndButton(){
      const v = currentVariantFromUi(variants, root) || variants[0];
      if (!v) return;

      // Update price
      if (priceEl){
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
          ? `<div class="price"><s class="price__compare">${money(v.compare_at_price)}</s> <span class="price__current">${money(v.price)}</span></div>`
          : `<div class="price"><span class="price__current">${money(v.price)}</span></div>`;
      }

      // Update Add button
      if (addBtn){
        addBtn.dataset.variantId = v.id;
        addBtn.disabled = !v.available;
      }
    }

    // Listen for changes from any option UI (generic or custom)
    const { selects, radioNames } = getOptionControls(root);
    selects.forEach(s => s.addEventListener('change', updatePriceAndButton));
    radioNames.forEach(name => {
      root.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach(r=>{
        r.addEventListener('change', updatePriceAndButton);
        r.addEventListener('click', updatePriceAndButton);
      });
    });

    // Initial sync to set price + button state
    updatePriceAndButton();

    // Add-to-cart with toast + CLOSE MODAL immediately after click
    addBtn?.addEventListener('click', (e)=>{
      e.preventDefault();
      toastNear(addBtn, 'Added to cart');    // show immediately
      const id = addBtn.dataset.variantId;
      closeModal();                          // <— close the picker right away
      if (!id) return;
      addToCart(id).catch(()=>{});           // still fire the add (silent if it fails)
    });
  }

  // ----- Capture icon clicks (separate from preview logic) -----
  ['pointerdown','click'].forEach(evt=>{
    document.addEventListener(evt, (e)=>{
      const add  = e.target.closest('.js-card-add');        // single variant
      const pick = e.target.closest('.js-card-pick-open');  // multi-variant
      if (!add && !pick) return;

      e.stopPropagation();
      if (evt !== 'click') return;
      e.preventDefault();

      if (add){
        const id = add.getAttribute('data-variant-id');
        toastNear(add, 'Added to cart');
        if (id) addToCart(id).catch(()=>{});
        return;
      }
      if (pick){
        openPicker(pick.getAttribute('data-handle'));
      }
    }, true);
  });
})();
